import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4 d-flex align-items-center" }
const _hoisted_2 = { class: "dialog-custom__title m-0" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"600px","height":"calc(100vh - 330px)"} }
const _hoisted_5 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_6 = { class: "text-gray" }
const _hoisted_7 = {
  key: 0,
  class: "app-loader app-loader--contextual"
}
const _hoisted_8 = { class: "ml-auto mr-1 text-gray building-info" }
const _hoisted_9 = { class: "checkbox-sublabel" }
const _hoisted_10 = { class: "bt-icon my-auto bt-icon--sm" }
const _hoisted_11 = { class: "bt-icon my-auto bt-icon--sm" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "align-items-center d-flex flex-column" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "warning" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { class: "old-new-changes" }
const _hoisted_18 = { class: "text-gray" }
const _hoisted_19 = { class: "old-new-title" }
const _hoisted_20 = { class: "old-new-title" }
const _hoisted_21 = { class: "text-gray" }
const _hoisted_22 = { class: "old-new-title" }
const _hoisted_23 = { class: "old-new-title" }
const _hoisted_24 = { class: "text-gray" }
const _hoisted_25 = { class: "old-new-title" }
const _hoisted_26 = { class: "old-new-title" }
const _hoisted_27 = { class: "text-gray" }
const _hoisted_28 = { class: "old-new-title" }
const _hoisted_29 = { class: "old-new-title" }
const _hoisted_30 = { class: "text-gray" }
const _hoisted_31 = { class: "old-new-title" }
const _hoisted_32 = { class: "old-new-title" }
const _hoisted_33 = { class: "dialog-custom__footer" }
const _hoisted_34 = {
  key: 0,
  style: {"margin":"0 15px","text-align":"start","font-style":"italic"}
}
const _hoisted_35 = { class: "ml-2" }
const _hoisted_36 = { class: "d-flex justify-content-between" }
const _hoisted_37 = { class: "d-flex justify-content-between" }
const _hoisted_38 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Chip = _resolveComponent("Chip")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogInfo = _resolveComponent("DialogInfo")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    modal: true,
    showHeader: false,
    onHide: _ctx.doHideDialog,
    closable: false,
    class: ["dialog-custom import-dialog", {'during-creation': _ctx.isCreationMode}]
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.subtitle), 1),
            (_ctx.dialogStep == 1)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-text p-0 ml-auto",
                  onClick: _ctx.selectAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("general.selectAll")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.dialogStep == 1)
            ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                key: 0,
                class: "dialog-scroll"
              }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode(_component_ProgressSpinner)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.firstStepList, (item, i) => {
                    return (_openBlock(), _createBlock(_component_ListItemCheck, {
                      key: i,
                      label: _ctx.formatLabel(item.data),
                      inputId: `checkbox-${i}`,
                      modelValue: item.selected,
                      "onUpdate:modelValue": ($event: any) => (item.selected = $event),
                      disabled: _ctx.checkIfDisabled(item),
                      name: `checkbox-${i}`,
                      last: i === _ctx.firstStepList.length - 1,
                      onClick: ($event: any) => (_ctx.manageLabelsMap(item)),
                      binary: ""
                    }, {
                      "checkbox-label": _withCtx(() => [
                        _createVNode("label", {
                          for: `checkbox-${i}`,
                          class: ["ml-2 d-flex align-items-center", { 'disabled-label': false }]
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.formatLabel(item.data)) + " ", 1),
                          _createVNode("small", _hoisted_8, _toDisplayString(item.data.buildingName) + " - " + _toDisplayString(item.data.apartmentName) + " - " + _toDisplayString(item.data.scsAddress), 1)
                        ], 8, ["for"])
                      ]),
                      "checkbox-sublabel": _withCtx(() => [
                        _createVNode("div", _hoisted_9, [
                          (item.data.badges.length > 0)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.data.badges, (b) => {
                                return (_openBlock(), _createBlock(_component_Chip, { key: b }, {
                                  default: _withCtx(() => [
                                    _createVNode("span", _hoisted_10, [
                                      _createVNode(_component_InlineSvgScoped, {
                                        src: require(`@/assets/images/entrancePlants/icon-badge.svg`),
                                        "aria-label": "icon-badge"
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("small", null, _toDisplayString(b), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            : _createCommentVNode("", true),
                          (item.data.keypadCode)
                            ? (_openBlock(), _createBlock(_component_Chip, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode("span", _hoisted_11, [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: require(`@/assets/images/entrancePlants/icon-locket.svg`),
                                      "aria-label": "icon-lock"
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("small", null, _toDisplayString(item.data.keypadCode), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "inputId", "modelValue", "onUpdate:modelValue", "disabled", "name", "last", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.dialogStep == 2)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode(_component_InlineSvgScoped, {
                    style: {"color":"blue"},
                    src: require(`@/assets/images/icons/icon-alert-medium-outline.svg`),
                    "aria-label": "icon-alert-medium-outline"
                  }, null, 8, ["src"]),
                  _createVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t("warning")), 1),
                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("warning.description")), 1)
                ]),
                _createVNode(_component_ElScrollbar, {
                  class: "dialog-scroll",
                  style: {"height":"calc(100vh - 630px)"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overwrited, (changes, i) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "d-flex flex-column align-item-left mr-3 ml-3",
                        key: i
                      }, [
                        _createVNode("div", _hoisted_16, [
                          _createVNode("h6", null, _toDisplayString(changes.recap.buildingName) + " - " + _toDisplayString(changes.recap.apartmentName), 1)
                        ]),
                        _createVNode("div", _hoisted_17, [
                          (changes.diffScs)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createVNode("div", _hoisted_18, [
                                  _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("oldScs")), 1),
                                  _createVNode("div", null, _toDisplayString(changes.recap.oldScsAddr), 1)
                                ]),
                                _createVNode("div", null, [
                                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("newScs")), 1),
                                  _createVNode("div", null, _toDisplayString(changes.recap.newScsAddr), 1)
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (changes.diffCallingCode)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createVNode("div", _hoisted_21, [
                                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("oldCallingCode")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': !changes.recap.oldCode}
                                  }, _toDisplayString(_ctx.formatCallingCode(changes.recap.oldCode)), 3)
                                ]),
                                _createVNode("div", null, [
                                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("newCallingCode")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': !changes.recap.newCode}
                                  }, _toDisplayString(_ctx.formatCallingCode(changes.recap.newCode)), 3)
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (changes.diffLabel)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                _createVNode("div", _hoisted_24, [
                                  _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("oldLines")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': changes.recap.oldLabels.length === 0}
                                  }, _toDisplayString(_ctx.formatApLabels(changes.recap.oldLabels)), 3)
                                ]),
                                _createVNode("div", null, [
                                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("newLines")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': changes.recap.newLabels.length === 0}
                                  }, _toDisplayString(_ctx.formatApLabels(changes.recap.newLabels)), 3)
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (changes.diffCode)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                _createVNode("div", _hoisted_27, [
                                  _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("oldCode")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': changes.recap.oldKeycode === ''}
                                  }, _toDisplayString(_ctx.formatCode(changes.recap.oldKeycode)), 3)
                                ]),
                                _createVNode("div", null, [
                                  _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("newCode")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': changes.recap.newKeycode === ''}
                                  }, _toDisplayString(_ctx.formatCode(changes.recap.newKeycode)), 3)
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (changes.diffBadge)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                                _createVNode("div", _hoisted_30, [
                                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("oldBadges")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': changes.recap.oldBadges.length === 0}
                                  }, _toDisplayString(_ctx.formatBadges(changes.recap.oldBadges)), 3)
                                ]),
                                _createVNode("div", null, [
                                  _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("newBadges")), 1),
                                  _createVNode("div", {
                                    class: {'no-data': changes.recap.newBadges.length === 0}
                                  }, _toDisplayString(_ctx.formatBadges(changes.recap.newBadges)), 3)
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("footer", _hoisted_33, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleButtonCancelAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button-raised p-button--m",
          onClick: _ctx.handleButtonSubmitAction,
          disabled: !_ctx.enableSaveButton
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.submitButtonLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      (_ctx.isPopupErrorVisible)
        ? (_openBlock(), _createBlock(_component_DialogInfo, {
            key: 0,
            "is-visible": _ctx.isPopupErrorVisible,
            title: _ctx.$t('import.importErrorTitle'),
            message: _ctx.popupErrorMessage,
            style: {"width":"400px"},
            onHideDialog: _ctx.hidePopupError
          }, {
            default: _withCtx(() => [
              (_ctx.popupErrorValues.importedValue && 
                      _ctx.popupErrorValues.importedAp && 
                      _ctx.popupErrorValues.dbApartment)
                ? (_openBlock(), _createBlock("div", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_ctx.$t('import.errorInfo')) + ": ", 1),
                    _createVNode("div", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _createTextVNode(_toDisplayString(_ctx.popupErrorValues.importedValue[0]) + ": ", 1),
                        _createVNode("b", null, _toDisplayString(_ctx.popupErrorValues.importedValue[1]), 1)
                      ]),
                      _createVNode("div", _hoisted_37, [
                        _createTextVNode(_toDisplayString(_ctx.$t('import.importedApartment')) + ": ", 1),
                        _createVNode("b", null, _toDisplayString(_ctx.popupErrorValues.importedAp), 1)
                      ]),
                      _createVNode("div", _hoisted_38, [
                        _createTextVNode(_toDisplayString(_ctx.$t('import.assignedTo')) + ": ", 1),
                        _createVNode("b", null, _toDisplayString(_ctx.popupErrorValues.dbApartment), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["is-visible", "title", "message", "onHideDialog"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onHide", "class"]))
}